import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	guideLineApi,
	guideLineApiBy,
	searchsKojinApiBy,
	searchsSisetuApiBy
} from 'interface/endpoints'
import {
  GuideLineResult,
  GuideLineResultList,
	GuideLineFormData,
	KojinsGuideLineResultList,
	SisetusGuideLineResultList
} from './types'

export * from './types'

export const useListGuideLine = (
	rareDiseaseId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<GuideLineResultList>(
        apiAccess,
        guideLineApi('/list', { rareDiseaseId }),
        cancelToken
      )
    },
		[rareDiseaseId]
	)
)

export const useGetGuideLine = (
	guideLineId: number | null | undefined,
	searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!guideLineId) return null
      return ApiGetWithToken<GuideLineResult>(
        apiAccess,
        guideLineApiBy(guideLineId, undefined, { searchId }),
        cancelToken
      )
    },
		[guideLineId, searchId]
	)
)

export const usePostGuideLine = (
  callback?: {
    onPosted?: (result: GuideLineResult) => void
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<GuideLineFormData, GuideLineResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        guideLineApi(),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditGuideLine = (
  guideLineId: number, 
	callback?: {
    onEditted?: (result: GuideLineResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<GuideLineFormData, GuideLineResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        guideLineApiBy(guideLineId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[guideLineId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteGuideLine = (
  callback?: {
    onDeleted?: (guideLineId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, guideLineId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        guideLineApiBy(guideLineId),
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useListGuideLineByKojin = (
	searchId: number | undefined | null,
	kojinCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !kojinCode) return null
      return ApiGetWithToken<KojinsGuideLineResultList>(
        apiAccess,
        searchsKojinApiBy(searchId, kojinCode, '/guideLine'),
        cancelToken
      )
    },
		[searchId, kojinCode]
	)
)

export const useListGuideLineBySisetu = (
	searchId: number | undefined | null,
	sisetuCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!searchId || !sisetuCode) return null
      return ApiGetWithToken<SisetusGuideLineResultList>(
        apiAccess,
        searchsSisetuApiBy(searchId, sisetuCode, '/guideLine'),
        cancelToken
      )
    },
		[searchId, sisetuCode]
	)
)
